// Crée le bouton
const scrollBtn = document.createElement('button');
scrollBtn.id = 'scrollToTopBtn';
scrollBtn.innerHTML = '↑';
scrollBtn.setAttribute('aria-label', 'Retour en haut de page');
scrollBtn.setAttribute('title', 'Retour en haut de page');
scrollBtn.style.display = 'none';
document.body.appendChild(scrollBtn);

// Affiche ou cache le bouton selon le scroll
window.addEventListener('scroll', () => {
  if (window.scrollY > 200) {
    scrollBtn.style.display = 'block';
  } else {
    scrollBtn.style.display = 'none';
  }
});

// Scroll en haut en douceur
scrollBtn.addEventListener('click', () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

// Nouvelle fonction pour attendre explicitement le chargement du script Leaflet
function onLeafletLoaded(callback) {
  if (typeof L !== 'undefined') {
    callback();
    return;
  }
  // Cherche le script Leaflet dans le DOM
  var leafletScript = document.querySelector('script[src*="leaflet"]');
  if (leafletScript) {
    leafletScript.addEventListener('load', callback);
  } else {
    // Si le script n'est pas encore dans le DOM, réessaie
    setTimeout(function() { onLeafletLoaded(callback); }, 200);
  }
}

function tryInitStoreLocationMap() {
  var mapContainer = document.getElementById('osm-map');
  if (!mapContainer) return;
  if (mapContainer.dataset.mapInitialized) return;
  mapContainer.dataset.mapInitialized = 'true';
  var map = L.map('osm-map', { scrollWheelZoom: false }).setView([48.44913, -68.52213], 17);
  // Fond de carte harmonieux : CartoDB Positron
  var tileLayer = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
    maxZoom: 19,
    attribution: '© OpenStreetMap, © CartoDB'
  });
  tileLayer.addTo(map);
  // Récupérer l'URL du logo du pin depuis le data-attribute
  var logoUrl = mapContainer.getAttribute('data-logo-pin') || "/cdn/shop/files/outdoors_army_logo2.png?width=60";
  var logoIcon = L.icon({
    iconUrl: logoUrl,
    iconSize: [60, null], // largeur 60px, hauteur auto
    iconAnchor: [30, 30], // ancre verticale centrée
    popupAnchor: [0, -30]
  });
  L.marker([48.44913, -68.52213], { icon: logoIcon }).addTo(map)
    .bindPopup('<strong>OutDoorsArmy</strong><br>570 F Rue Saint-Germain Est<br>Rimouski, QC G5L 1G4')
    .openPopup();
}

document.addEventListener('DOMContentLoaded', function() {
  onLeafletLoaded(tryInitStoreLocationMap);
}); 